import { axiosClient } from "./axiosClient";
import { SECONDARY_ENDPOINTS } from "./endpoints";

import {
    AddSecondaryNumberRequest,
    SecondaryOtpVerifyRequest,
} from "./api.types";

export const listSecondaryNumbers = async () => {
    const res = await axiosClient.post(
        SECONDARY_ENDPOINTS.LIST
    );
    return res.data;
};

export const addSecondaryNumber = async (payload: AddSecondaryNumberRequest) => {
    const res = await axiosClient.post(
        SECONDARY_ENDPOINTS.ADD,
        payload
    );
    return res.data;
};

export const verifySecondaryOtp = async (payload: SecondaryOtpVerifyRequest) => {
    const res = await axiosClient.post(
        SECONDARY_ENDPOINTS.VERIFY,
        payload
    );
    return res.data;
};
